// extracted by mini-css-extract-plugin
export default {"float":"styles_float__uDKzT","create-button":"styles_create-button__3zUzD","icon":"styles_icon__58V-a"};